(function () {
	'use strict';

    angular.module("imApp").factory("pohTopsService", ['$ihttp', function ($ihttp) {
		let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1347,
                    parameters: parms || {}
                });
            },
            listPohTops: function (parms) {
                return $ihttp.post({
                    method: 1349,
                    parameters: parms || {}
                });
            },
            checkOrder: function (setting) {
                return $ihttp.post({
                    method: 1357,
                    parameters: setting
                });
            },
            setNewStatus: function (setting) {
                return $ihttp.post({
                    method: 1573,
                    parameters: setting
                });
            }
		};

		return service;
	}]);
})();
